"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.footnoteLinks = exports.appDownloads = exports.socialList = exports.helpNav = exports.nutritionNav = exports.shopNav = exports.companyNav = exports.trainersNav = exports.workoutProgramNav = exports.logoNav = void 0;
exports.logoNav = { link: "https://campgladiator.com/" };
exports.workoutProgramNav = [
    { link: "https://campgladiator.com/pricing", text: "Pricing" },
    {
        link: "https://campgladiator.com/programs/camp",
        text: "Program Overview",
    },
    {
        link: "https://campgladiator.com/programs/camp/outdoor-locations",
        text: "Outdoor Locations",
    },
    {
        link: "https://account.campgladiator.com/#/virtual-workouts",
        text: "Live Online Workouts",
    },
    {
        link: "https://ondemand.campgladiator.com/",
        text: "On-Demand Online Workouts",
    },
];
exports.trainersNav = [
    {
        link: "https://campgladiator.com/trainers/about-our-trainers",
        text: "About Our Trainers",
    },
    {
        link: "https://campgladiator.com/trainers/become-a-trainer",
        text: "Become a Trainer",
    },
];
exports.companyNav = [
    { link: "https://campgladiator.com/company/about", text: "About Us" },
    { link: "https://campgladiator.com/blog", text: "Blog" },
    { link: "https://campgladiator.com/company/careers", text: "Careers" },
    {
        link: "https://campgladiator.com/company/community-guidelines",
        text: "Community Guidelines",
    },
    {
        link: "https://campgladiator.com/company/corporate-wellness",
        text: "Corporate Wellness",
    },
    {
        link: "https://campgladiator.com/company/military-discount",
        text: "Military Discount",
    },
];
exports.shopNav = [
    { link: "https://gear.campgladiator.com", text: "Gear Store" },
];
exports.nutritionNav = [
    {
        link: "https://campgladiator.com/programs/nutrition",
        text: "Overview & Pricing",
    },
];
exports.helpNav = [
    { link: "https://cgmembersupport.zendesk.com", text: "FAQ" },
    { link: "https://campgladiator.com/contact", text: "Contact" },
    {
        link: "https://campgladiator.com/help/return-policy",
        text: "Return Policy",
    },
];
exports.socialList = [
    {
        icon: "icon-facebook-f",
        title: "Facebook Page",
        link: "https://www.facebook.com/CampGladiator/",
    },
    {
        icon: "icon-instagram",
        title: "Instagram Profile",
        link: "https://www.instagram.com/campgladiator/",
    },
    {
        icon: "icon-youtube",
        title: "YouTube Channel",
        link: "https://www.youtube.com/user/CampGladiator",
    },
];
exports.appDownloads = [
    {
        brand: "Apple Store",
        size: "default",
        theme: "light",
        name: "Download on the App Store",
    },
    {
        brand: "Google Play",
        size: "default",
        theme: "light",
        name: "Get it on Play Store",
    },
];
exports.footnoteLinks = [
    { text: "terms & conditions", link: "https://campgladiator.com/legal/terms" },
    {
        text: "privacy policy",
        link: "https://campgladiator.com/legal/privacy-policy",
    },
];
//# sourceMappingURL=footerData.js.map